import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import { FAQAccordion } from "@/components/FAQAccordion";
import { CTASection } from "@/components/CTASection";
import { FAQS } from "@/lib/faqs";
import { buildFaqPage, buildBreadcrumbs } from "@/components/SchemaJsonLd";
import flakeImg from "@/assets/flake-closeup.jpg";

export const Route = createFileRoute("/faqs")({
  head: () => ({
    meta: [
      { title: "Garage Floor Coating FAQs | MLC Epoxy Floors" },
      { name: "description", content: "Answers to the most common questions about epoxy and polyaspartic garage floor coatings — cost, lifespan, prep, maintenance, and more." },
      { property: "og:title", content: "Garage Floor Coating FAQs | MLC Epoxy Floors" },
      { property: "og:description", content: "25+ expert answers on garage floor coatings — pricing, polyaspartic, prep, durability." },
      { property: "og:url", content: "/faqs" },
    ],
    links: [{ rel: "canonical", href: "/faqs" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(FAQS)) },
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([{ name: "Home", href: "/" }, { name: "FAQs", href: "/faqs" }])) },
    ],
  }),
  component: FaqsPage,
});

function FaqsPage() {
  return (
    <>
      <PageHero eyebrow="Frequently Asked" title="Garage Floor Coating FAQs" body="Everything Calgary Region homeowners ask us about epoxy, polyaspartic, pricing, prep, and maintenance." image={flakeImg} />
      <section className="container-x py-20">
        <FAQAccordion items={FAQS} />
      </section>
      <CTASection />
    </>
  );
}
